import { render, staticRenderFns } from "./CAxACOxClarificationsPage.vue?vue&type=template&id=5055f47c"
import script from "./CAxACOxClarificationsPage.vue?vue&type=script&lang=js"
export * from "./CAxACOxClarificationsPage.vue?vue&type=script&lang=js"
import style0 from "./CAxACOxClarificationsPage.vue?vue&type=style&index=0&id=5055f47c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports